import React from "react";

// Styling
import "../../Styles/MainPage.scss";
const NavbarLeft = () => {
  // Console logo SVG format
  const logo = "https://weaviate.io/img/site/weaviate-nav-logo-light.svg";

  return (
    <div className="__navbarLeft">
      <img
        src={logo}
        alt="Logo"
        onClick={() => {
          const { origin, pathname} = window.location;
          let target = origin;
          if (pathname.startsWith('/console/wcs')) {
            target = `${window.location.origin}/console/wcs`;
          }
          
          if (pathname.startsWith('/console/query')) {
            target = `${window.location.origin}/console/query`;
          }
          
          window.location.href = target;
        }}
      />
    </div>
  );
};

export default NavbarLeft;
